module.exports = __webpack_public_path__ + "images/cv_btn_2b892c2485a4aaca024ce15f19a1b8cc.png";